<!-- Mobile layout: dark cover with the title, a floating action card, the details, then the items and info panels.
     It shows the same keys as the desktop details page (resource-details-info and the per-type components). -->
<ng-container *ngIf="isMobile | async">
    <div *ngIf="user$ | async; let user" class="cd-mobile">
        <div class="cd-cover">
            <app-image-view
                [media_id]="resource.media$"
                [paddingBottom]="'80%'"
                [showImgModalOnClick]="false"
                (srcLoaded)="mediaUrl = $event"
            ></app-image-view>
            <div class="cd-cover-shade"></div>
            <div class="cd-cover-content">
                <div class="cd-cover-bar">
                    <img
                        *ngIf="resource.public; else orgName"
                        class="cd-org-logo"
                        src="assets/images/KD_KOL_logo_long_white.png"
                        alt="KlickData"
                    />
                    <ng-template #orgName>
                        <span class="cd-org">{{ coverOrgName$ | async }}</span>
                    </ng-template>
                    <button
                        *ngIf="hasTrailerOrPresentation"
                        type="button"
                        class="cd-play"
                        aria-label="Play Trailer"
                        i18n-aria-label="@@playTrailer"
                        (click)="playCover(resource)"
                    >
                        <mat-icon>play_arrow</mat-icon>
                    </button>
                </div>
                <h1 class="cd-title" data-testid="resource-detail-title">{{ resource.title }}</h1>
            </div>
        </div>

        <section class="cd-card cd-head">
            <div class="cd-action-card">
                <ng-container *ngIf="resource.price">
                    <ng-container *ngIf="customer$ | async; let customer">
                        <div *ngIf="customer.license_type === 'sitelicense'; else paidPrice" class="cd-price">
                            <span class="cd-price-value" i18n>FREE!</span>
                            <span class="cd-muted">
                                <span i18n>Free for Site license clients</span>. <span i18n>Ordinary price</span>:
                                {{ resource.price }}&nbsp;{{ resource.currency }}
                            </span>
                        </div>
                        <ng-template #paidPrice>
                            <div *ngIf="resource.purchased; else toPay" class="cd-price">
                                <span class="cd-price-value" i18n>Purchased!</span>
                                <span class="cd-muted">
                                    <span i18n>Ordinary price</span>: {{ resource.price }}&nbsp;{{ resource.currency }}
                                </span>
                            </div>
                            <ng-template #toPay>
                                <div class="cd-price">
                                    <span class="cd-price-value"
                                        >{{ resource.price }}&nbsp;{{ resource.currency }}</span
                                    >
                                </div>
                            </ng-template>
                        </ng-template>
                    </ng-container>
                </ng-container>

                <ng-container [ngTemplateOutlet]="actionBtn" [ngTemplateOutletContext]="{ user: user }"></ng-container>

                <div class="cd-quick-actions">
                    <button
                        type="button"
                        class="cd-icon-btn"
                        data-testid="resource-detail-favorite"
                        aria-label="Add to favorite"
                        i18n-aria-label="@@addToFavorite"
                        (click)="favoriteResource(resource)"
                    >
                        <mat-icon>{{ resource.favorite ? 'star' : 'star_border' }}</mat-icon>
                    </button>
                    <button
                        type="button"
                        class="cd-icon-btn"
                        aria-label="Like"
                        i18n-aria-label="@@like"
                        (click)="likeResource(resource)"
                    >
                        <mat-icon>{{ resource.like ? 'favorite' : 'favorite_border' }}</mat-icon>
                    </button>
                    <button
                        *ngIf="resource.published"
                        type="button"
                        class="cd-icon-btn"
                        aria-label="Invite a friend"
                        i18n-aria-label
                        (click)="invite(resource)"
                    >
                        <mat-icon>outgoing_mail</mat-icon>
                    </button>
                    <!-- Same permissions as the desktop info page -->
                    <ng-container
                        *ngIf="{
                            canAssign:
                                resource.user_collaboration?.tutor?.status &&
                                user.role_value !== 'user' &&
                                user.role_value !== 'guest' &&
                                user.canAssign(resource),
                            canEdit: resource.user_collaboration?.edit?.status && user.canEdit(resource),
                            isMember: user.role_value !== 'guest'
                        } as more"
                    >
                        <ng-container
                            *ngIf="
                                resource.medias?.presentation?.length ||
                                resource.last_publish ||
                                resource.downloads ||
                                more.canAssign ||
                                more.canEdit ||
                                more.isMember
                            "
                        >
                            <button
                                type="button"
                                class="cd-icon-btn"
                                aria-label="More"
                                i18n-aria-label="@@more"
                                [matMenuTriggerFor]="moreMenu"
                            >
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                            <mat-menu #moreMenu="matMenu">
                                <button
                                    *ngIf="resource.medias?.presentation?.length"
                                    mat-menu-item
                                    (click)="playVideo(resource.medias.presentation[0])"
                                >
                                    <mat-icon>slideshow</mat-icon>
                                    <span i18n>See presentation</span>
                                </button>
                                <button
                                    *ngIf="resource.last_publish"
                                    mat-menu-item
                                    [disabled]="shareLoading | async"
                                    (click)="shareService.openShareDialog(resource, shareLoading)"
                                >
                                    <mat-icon>share</mat-icon>
                                    <span i18n="@@share">Share</span>
                                </button>
                                <button *ngIf="resource.downloads" mat-menu-item (click)="download(resource)">
                                    <mat-icon>save_alt</mat-icon>
                                    <span i18n="@@download">Download</span>
                                </button>
                                <button *ngIf="more.canAssign" mat-menu-item (click)="assign(resource)">
                                    <mat-icon>assignment_ind</mat-icon>
                                    <span *ngIf="!resource.assign_id" i18n="@@assign">Assign</span>
                                    <span *ngIf="resource.assign_id">{{ editAssignLabel }}</span>
                                </button>
                                <button
                                    *ngIf="more.canEdit"
                                    mat-menu-item
                                    (click)="editResource(resource, user.isAdmin())"
                                >
                                    <mat-icon>create</mat-icon>
                                    <span i18n="@@edit">Edit</span>
                                </button>
                                <ng-container *ngIf="more.isMember">
                                    <button mat-menu-item (click)="showResLog()">
                                        <mat-icon>history_toggle_off</mat-icon>
                                        <span i18n>History</span>
                                    </button>
                                    <button mat-menu-item (click)="showResNotes()">
                                        <mat-icon>note_alt</mat-icon>
                                        <span i18n>Notes</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <app-occasions-dates-viewer
                *ngIf="
                    (resourceType === ResourceTypes.COURSE || resourceType === ResourceTypes.EVENT) &&
                    !resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_always_open &&
                    occasionDates?.length
                "
                class="cd-occasions"
                [resourceLabel]="resourceLabel"
                [dates]="occasionDates"
                [canShowMore]="true"
                [timeZone]="resource.time_zone"
            ></app-occasions-dates-viewer>

            <span *ngIf="$any(resource.publishers)?.length" class="cd-muted cd-published">
                <span i18n>Published by</span>
                <span>{{ $any(resource.publishers)[0].name }}</span>
            </span>
            <p *ngIf="resource.bullets" class="cd-bullets">{{ resource.bullets }}</p>

            <!-- The desktop info circles and short detail rows, as chips -->
            <div class="cd-facts">
                <span class="cd-fact">
                    <mat-icon *ngIf="typeIcon.fontIcon" fontSet="klickdata" [fontIcon]="typeIcon.fontIcon"></mat-icon>
                    <mat-icon *ngIf="typeIcon.icon">{{ typeIcon.icon }}</mat-icon>
                    <span>{{ (resource | resourceDefaultNameDisplay : false | async) || resourceLabel }}</span>
                </span>
                <span class="cd-fact cd-fact-lang">
                    <app-language-selector
                        [language_id]="resource.language_id"
                        [showLabel]="true"
                        tooltip="Language"
                        i18n-tooltip="@@language"
                    ></app-language-selector>
                </span>
                <ng-container
                    *ngIf="
                        resourceType !== ResourceTypes.MATERIAL &&
                            resourceType !== ResourceTypes.EVENT &&
                            (resourceItems$ | async);
                        let items
                    "
                >
                    <!-- Courses, e-courses and SCORM list their items below, so the chip scrolls there -->
                    <button
                        *ngIf="items.length && hasItemList; else itemsFact"
                        type="button"
                        class="cd-fact cd-fact-link"
                        (click)="scrollToItems()"
                    >
                        <mat-icon>format_list_numbered</mat-icon>
                        <ng-container
                            [ngTemplateOutlet]="itemsCountTpl"
                            [ngTemplateOutletContext]="{ $implicit: items.length }"
                        ></ng-container>
                        <mat-icon class="cd-fact-hint">expand_more</mat-icon>
                    </button>
                    <ng-template #itemsFact>
                        <span *ngIf="items.length" class="cd-fact">
                            <mat-icon>{{
                                resourceType === ResourceTypes.SURVEY || resourceType === ResourceTypes.TEST
                                    ? 'quiz'
                                    : 'format_list_numbered'
                            }}</mat-icon>
                            <ng-container
                                [ngTemplateOutlet]="
                                    resourceType === ResourceTypes.SURVEY || resourceType === ResourceTypes.TEST
                                        ? questionsCountTpl
                                        : itemsCountTpl
                                "
                                [ngTemplateOutletContext]="{ $implicit: items.length }"
                            ></ng-container>
                        </span>
                    </ng-template>
                </ng-container>
                <span *ngIf="hasDuration(resource.duration)" class="cd-fact">
                    <mat-icon>timelapse</mat-icon>
                    <span>{{
                        resource.duration
                            | formatIsoDuration
                                : resourceType === ResourceTypes.E_COURSE || resourceType === ResourceTypes.SCORM
                    }}</span>
                </span>
                <span *ngIf="resource.time_limit" class="cd-fact">
                    <mat-icon>timer</mat-icon>
                    <span>{{ resource.time_limit | formatIsoDuration }}</span>
                </span>
                <span *ngIf="resource.examination?.label" class="cd-fact">
                    <mat-icon>military_tech</mat-icon>
                    <span>{{ resource.examination?.label }}</span>
                </span>
                <span *ngIf="resource.article_code" class="cd-fact">
                    <mat-icon>center_focus_strong</mat-icon>
                    <!-- Same per-type labels as the desktop page, so they reuse its translations -->
                    <span [ngSwitch]="resourceType">
                        <span *ngSwitchCase="ResourceTypes.E_COURSE" i18n>E-Course code</span>
                        <span *ngSwitchCase="ResourceTypes.EVENT" i18n>Event code</span>
                        <span *ngSwitchCase="ResourceTypes.MATERIAL" i18n>Material code</span>
                        <span *ngSwitchCase="ResourceTypes.SCORM" i18n>SCORM code</span>
                        <span *ngSwitchCase="ResourceTypes.SURVEY" i18n>Survey code</span>
                        <span *ngSwitchCase="ResourceTypes.TEST" i18n>Test code</span>
                        <span *ngSwitchDefault i18n>Course code</span>: {{ resource.article_code }}
                    </span>
                </span>
                <span *ngIf="resourceType === ResourceTypes.EVENT && eventType" class="cd-fact">
                    <mat-icon>{{ eventType.icon }}</mat-icon>
                    <span>{{ eventType.title }}</span>
                </span>
                <span
                    *ngIf="
                        resource.always_available &&
                        (resourceType === ResourceTypes.COURSE || resourceType === ResourceTypes.EVENT)
                    "
                    class="cd-fact"
                >
                    <mat-icon>event_available</mat-icon>
                    <span i18n>Available</span>
                </span>
                <span *ngIf="resource.public" class="cd-fact">
                    <mat-icon>public</mat-icon>
                    <span i18n="@@public">Public</span>
                </span>
            </div>

            <!-- Author (Tutor for events): the resource managers -->
            <ng-container
                *ngIf="$any(resource.managers)?.length"
                [ngTemplateOutlet]="staffBlock"
                [ngTemplateOutletContext]="{ staff: $any(resource.managers), size: 'large', label: managerLabel }"
            ></ng-container>
            <ng-template #managerLabel>
                <span *ngIf="resourceType === ResourceTypes.EVENT" i18n="@@tutor">Tutor</span>
                <span *ngIf="resourceType !== ResourceTypes.EVENT" i18n="@@author">Author</span>
            </ng-template>
        </section>

        <!-- Items: picture cards for a course, a chapter list for e-course and SCORM. Tests and surveys only show the count. -->
        <ng-container *ngIf="resourceItems$ | async; let items">
            <section
                *ngIf="items.length && resourceType === ResourceTypes.COURSE"
                class="cd-card cd-items cd-items-anchor"
            >
                <h2 class="cd-section-title">
                    <span>{{ resourceLabel }} <span i18n="@@include">include</span></span>
                    <span class="cd-muted">({{ items.length }})</span>
                </h2>
                <div class="cd-items-track">
                    <button
                        *ngFor="let item of items; let index = index"
                        type="button"
                        class="cd-item"
                        data-testid="resource-detail-item"
                        (click)="startCoursePopUp(resource, user, item)"
                    >
                        <div class="cd-item-media">
                            <app-image-view
                                [smallSpinner]="true"
                                [media_id]="item.media$"
                                [proportional]="true"
                                [showImgModalOnClick]="false"
                            ></app-image-view>
                            <span class="cd-item-index" [class.cd-item-done]="!!item.child_opportunity_done">
                                <mat-icon *ngIf="item.child_opportunity_done; else itemIndex">check</mat-icon>
                                <ng-template #itemIndex>{{ index + 1 }}</ng-template>
                            </span>
                        </div>
                        <span class="cd-item-body">
                            <span class="cd-item-type">
                                <mat-icon
                                    fontSet="klickdata"
                                    [fontIcon]="displayCorrectIcon(item.item_type_value)"
                                ></mat-icon>
                                <span *ngIf="item.question_count"
                                    >(<ng-container
                                        [ngTemplateOutlet]="questionsCountTpl"
                                        [ngTemplateOutletContext]="{ $implicit: item.question_count }"
                                    ></ng-container
                                    >)</span
                                >
                            </span>
                            <span class="cd-item-name">{{ item.title || item.name }}</span>
                            <span *ngIf="item.item_type_value === 'test' && item.passing_level" class="cd-item-rules">
                                <span *ngIf="item.passing_level.percentage">
                                    <mat-icon>verified</mat-icon>{{ item.passing_level.percentage }}%
                                </span>
                                <span *ngIf="item.passing_level.repeats != null">
                                    <mat-icon>replay</mat-icon>{{ item.passing_level.repeats }}
                                </span>
                            </span>
                        </span>
                    </button>
                </div>
            </section>

            <section
                *ngIf="
                    items.length && (resourceType === ResourceTypes.E_COURSE || resourceType === ResourceTypes.SCORM)
                "
                class="cd-card cd-items-anchor"
            >
                <h2 class="cd-section-title">
                    <span *ngIf="resourceType === ResourceTypes.E_COURSE"
                        >{{ resourceLabel }} <span i18n="@@include">include</span></span
                    >
                    <span *ngIf="resourceType === ResourceTypes.SCORM">{{ resource.title }}</span>
                    <span class="cd-muted">({{ items.length }})</span>
                </h2>
                <ol class="cd-chapters">
                    <li *ngFor="let item of items; let index = index">
                        <button
                            type="button"
                            class="cd-chapter"
                            data-testid="resource-detail-item"
                            [class.cd-chapter-child]="
                                resourceType === ResourceTypes.SCORM ? !!item.sco_parent_id : !!item.parent_id
                            "
                            (click)="startCoursePopUp(resource, user, item)"
                        >
                            <span class="cd-item-index" [class.cd-item-done]="!!item.child_opportunity_done">
                                <mat-icon *ngIf="item.child_opportunity_done; else chapterIndex">check</mat-icon>
                                <ng-template #chapterIndex>{{ index + 1 }}</ng-template>
                            </span>
                            <!-- As on desktop: e-course chapters use the name (the title is only a number), SCORM uses the SCO title -->
                            <span class="cd-chapter-name">{{
                                resourceType === ResourceTypes.SCORM ? item.title || item.name : item.name
                            }}</span>
                        </button>
                    </li>
                </ol>
            </section>
        </ng-container>

        <section *ngIf="resource.description" class="cd-card cd-about">
            <h2 class="cd-section-title">
                <span>{{ resourceLabel }} <span i18n="@@description">description</span></span>
            </h2>
            <div
                class="cd-desc"
                [class.cd-desc-clamp]="resource.description.length > 300 && !showFullDescription"
                [innerHtml]="resource.description | innerHtml : 'info'"
            ></div>
            <button
                *ngIf="resource.description.length > 300"
                type="button"
                class="cd-link"
                (click)="showFullDescription = !showFullDescription"
            >
                <span *ngIf="!showFullDescription" i18n="@@ReadMore">Read more</span>
                <span *ngIf="showFullDescription" i18n>Read less</span>
            </button>
        </section>

        <!-- Text sections in the desktop order and with the desktop titles, then the desktop detail rows -->
        <mat-accordion class="cd-card cd-panels" displayMode="flat" [multi]="true">
            <mat-expansion-panel *ngIf="resource.goal">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ resourceLabel }}&nbsp;<span i18n="@@goal">goal</span></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="cd-text" [innerHtml]="resource.goal | innerHtml : 'info'"></div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.agenda">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ resourceLabel }}&nbsp;<span i18n="@@agenda">agenda</span></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="cd-text" [innerHtml]="resource.agenda | innerHtml : 'info' : 'agenda-wrapper'"></div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="!!resource.other_info && resource.metadata?.other_info">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        >{{ resourceLabel }}&nbsp;<span i18n="@@otherInformation"
                            >other information</span
                        ></mat-panel-title
                    >
                </mat-expansion-panel-header>
                <div class="cd-text" [innerHtml]="resource.other_info | innerHtml : 'info'"></div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.audience">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ resourceLabel }}&nbsp;<span i18n>audience</span></mat-panel-title>
                </mat-expansion-panel-header>
                <p class="cd-text">{{ resource.audience }}</p>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.episode">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ resourceLabel }}&nbsp;<span i18n>occasions</span></mat-panel-title>
                </mat-expansion-panel-header>
                <p class="cd-text">{{ resource.episode }}</p>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.instructions">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        >{{ resourceLabel }}&nbsp;<span i18n="@@instruction">instruction</span></mat-panel-title
                    >
                </mat-expansion-panel-header>
                <div class="cd-text" [innerHtml]="resource.instructions | innerHtml : 'info'"></div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.pre_skills">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        >{{ resourceLabel }}&nbsp;<span i18n="@@preskills">preskills</span></mat-panel-title
                    >
                </mat-expansion-panel-header>
                <div class="cd-text" [innerHtml]="resource.pre_skills | innerHtml : 'info'"></div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="resource.medias?.screenshot?.length > 0 && resource.medias?.screenshot[0]">
                <mat-expansion-panel-header>
                    <mat-panel-title i18n="@@screenshotImage">Screenshot image</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="cd-screenshot">
                    <app-image-view [media_id]="resource.medias?.screenshot[0]" [proportional]="false"></app-image-view>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ resourceLabel }}&nbsp;<span i18n="@@specifications">specifications</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <dl class="cd-specs">
                    <ng-container *ngIf="resourceType === ResourceTypes.EVENT && eventType">
                        <dt i18n>Event</dt>
                        <dd>{{ eventType.title }}</dd>
                    </ng-container>
                    <dt i18n="@@createdBy">Created by</dt>
                    <dd>{{ resource.author_name || $any(resource.author$ | async)?.name }}</dd>
                    <ng-container *ngIf="visibleEditors.length">
                        <dt i18n="@@editors">Editors</dt>
                        <dd>
                            <ng-container
                                [ngTemplateOutlet]="staffBlock"
                                [ngTemplateOutletContext]="{ staff: visibleEditors }"
                            ></ng-container>
                        </dd>
                    </ng-container>
                    <ng-container *ngIf="$any(resource.educators)?.length">
                        <dt i18n="@@educators">Educators</dt>
                        <dd>
                            <ng-container
                                [ngTemplateOutlet]="staffBlock"
                                [ngTemplateOutletContext]="{ staff: $any(resource.educators) }"
                            ></ng-container>
                        </dd>
                    </ng-container>
                    <ng-container *ngIf="$any(resource.hosts)?.length">
                        <dt i18n="@@hosts">Hosts</dt>
                        <dd>
                            <ng-container
                                [ngTemplateOutlet]="staffBlock"
                                [ngTemplateOutletContext]="{ staff: $any(resource.hosts) }"
                            ></ng-container>
                        </dd>
                    </ng-container>
                    <ng-container *ngIf="$any(resource.organizers)?.length">
                        <dt i18n="@@organizer">Organizer</dt>
                        <dd>
                            <ng-container
                                [ngTemplateOutlet]="staffBlock"
                                [ngTemplateOutletContext]="{ staff: $any(resource.organizers) }"
                            ></ng-container>
                        </dd>
                    </ng-container>
                    <ng-container *ngIf="hasDuration(resource.duration)">
                        <dt i18n="@@duration">Duration</dt>
                        <dd>{{ resource.duration | formatIsoDuration : false }}</dd>
                    </ng-container>
                    <ng-container *ngIf="resource.total_seats">
                        <dt i18n>Available seats</dt>
                        <dd>{{ resource.total_seats }}</dd>
                    </ng-container>
                    <ng-container *ngIf="resource.extra_seats">
                        <dt i18n>Extra seats</dt>
                        <dd>{{ resource.extra_seats }}</dd>
                    </ng-container>
                </dl>

                <ng-container *ngIf="resource.tags_attached && (resourceTags$ | async); let tags">
                    <h3 *ngIf="tags.length" class="cd-sub-title" i18n="@@tags">Tags</h3>
                    <div class="cd-chips">
                        <!-- The language selector is a button itself, so the chip is a wrapper, not a button -->
                        <span
                            *ngFor="let tag of showAllTags ? tags : (tags | slice : 0 : visibleTagsCount)"
                            class="cd-chip cd-chip-tag"
                        >
                            <button
                                type="button"
                                class="cd-chip-btn"
                                [disabled]="user.role_value === 'guest'"
                                (click)="showTagResources(tag)"
                            >
                                {{ tag.name }}
                            </button>
                            <app-language-selector [language_id]="tag.language_id"></app-language-selector>
                        </span>
                        <button
                            *ngIf="tags.length > visibleTagsCount"
                            type="button"
                            class="cd-link"
                            (click)="showAllTags = !showAllTags"
                        >
                            <span *ngIf="!showAllTags"><span i18n>Show all</span> ({{ tags.length }})</span>
                            <span *ngIf="showAllTags" i18n>Show less</span>
                        </button>
                    </div>
                </ng-container>

                <ng-container *ngIf="resourceCategories$ | async as cats">
                    <h3 *ngIf="cats.length" class="cd-sub-title" i18n="@@categories">Categories</h3>
                    <div class="cd-chips">
                        <button
                            *ngFor="let cat of cats"
                            type="button"
                            class="cd-chip cd-chip-cat"
                            [disabled]="user.role_value === 'guest'"
                            (click)="showCatgeoryResources(cat)"
                        >
                            {{ cat.title }}
                        </button>
                    </div>
                </ng-container>

                <div *ngIf="qrCodeData$ | async; let qrCodeData" class="cd-qr">
                    <h3 class="cd-sub-title"><span i18n>Qr code </span></h3>
                    <ngx-qrcode qrc-element-type="url" [value]="qrCodeData"></ngx-qrcode>
                </div>

                <!-- Logged-in tools, as on desktop -->
                <div *ngIf="user.role_value !== 'guest' && resource.quote_ids" class="cd-tools">
                    <button type="button" class="cd-tool" (click)="showQuotesInSlide()">
                        <mat-icon>format_quote</mat-icon>
                        <span i18n="@@quotes">Quotes</span>
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <app-footer></app-footer>
    </div>
</ng-container>

<!-- Up to two avatars and "Anna & Bo & others", as the desktop staff rows; opens the people side panel -->
<!-- Plurals live in one place each, so every use shares one translation -->
<ng-template #itemsCountTpl let-count>
    <span i18n>{count, plural, =1 {1 item} other {{{ count }} items}}</span>
</ng-template>
<ng-template #questionsCountTpl let-count>
    <span i18n>{count, plural, =1 {1 question} other {{{ count }} questions}}</span>
</ng-template>
<ng-template #staffBlock let-staff="staff" let-size="size" let-label="label">
    <button
        type="button"
        class="cd-staff btn"
        [class.cd-staff-large]="size === 'large'"
        (click)="showManagers(staff, resource)"
    >
        <span class="cd-avatars span">
            <span *ngFor="let member of staff | slice : 0 : 2" class="cd-avatar">
                <app-image-view
                    [scope]="AppScope.USERS"
                    [media_id]="$any(member)?.media$"
                    [isCircularImg]="true"
                    [showImgModalOnClick]="false"
                    [paddingBottom]="'100%'"
                ></app-image-view>
            </span>
            <span *ngIf="staff.length > 2" class="cd-avatar cd-avatar-more">+{{ staff.length - 2 }}</span>
        </span>
        <span class="cd-staff-text">
            <span class="cd-staff-names">
                {{ staff[0]?.name }}<ng-container *ngIf="staff.length > 1"> &amp; {{ staff[1]?.name }}</ng-container
                ><ng-container *ngIf="staff.length > 2">&nbsp;<span i18n>&amp; others</span></ng-container>
            </span>
            <span *ngIf="label" class="cd-muted"><ng-container [ngTemplateOutlet]="label"></ng-container></span>
        </span>
    </button>
</ng-template>

<!-- Notes side panel, same as the desktop info page -->
<ng-template #resourceNotesTpl>
    <div class="cd-notes" *ngIf="resourceNotes$ | async as notes; else notesLoading">
        <ng-container *ngIf="notes.length; else noNotes">
            <div class="cd-note" *ngFor="let note of notes">
                <span class="cd-muted">{{ note.created_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
                <span *ngIf="note.author && (note.author.fname || note.author.lname)" class="cd-muted">
                    <span i18n>By:</span> {{ note.author?.fname }} {{ note.author?.lname }}
                </span>
                <span *ngIf="note.body">{{ note.body }}</span>
            </div>
        </ng-container>
        <ng-template #noNotes>
            <span i18n>No notes for this resource.</span>
        </ng-template>
    </div>
    <ng-template #notesLoading>
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </ng-template>
</ng-template>

<!-- Old layout, kept as it was. It is not shown while the mobile layout above is. -->
<div *ngIf="!(isMobile | async) && (user$ | async); let user" class="layout res-details-page course-details-wrapper">
    <div fxLayout="column" class="relative">
        <div class="mb-1 bg-wrapper">
            <div class="lay-over"></div>
            <app-image-view
                [paddingBottom]="'450px'"
                [media_id]="(resource.medias?.background?.length && resource.medias?.background[0]) || resource.media"
                (srcLoaded)="mediaUrl = $event"
            >
            </app-image-view>
        </div>
        <div class="course-content-wrapper" fxLayout="column">
            <div class="pre-wrapper" fxLayout="row" fxLayoutGap="3em">
                <!-- Main img and course items in desktop -->
                <div *ngIf="!(isMobile | async)" class="left-info-wrapper" fxLayout="column">
                    <div class="kd-lib">
                        <ng-container
                            [ngTemplateOutlet]="academyLogo"
                            [ngTemplateOutletContext]="{ resource: resource }"
                        ></ng-container>
                    </div>
                    <div class="main-img">
                        <app-image-view
                            *ngIf="!(trailerMedia$ | async)"
                            [media_id]="resource.media$"
                            (srcLoaded)="mediaUrl = $event"
                        ></app-image-view>
                        <app-media-view
                            class="trailer-media"
                            *ngIf="trailerMedia$ | async"
                            [media]="trailerMedia$ | async"
                        >
                        </app-media-view>
                    </div>

                    <ng-container
                        *ngIf="resourceType !== ResourceTypes.MATERIAL && resourceType !== ResourceTypes.EVENT"
                    >
                        <div *ngIf="resourceItems$ | async; let items" class="res-items mt-1" fxLayout="column">
                            <div fxLayoutGap="7px" fxLayoutAlign="start center" class="items-label">
                                <mat-icon>category</mat-icon>
                                <span
                                    >{{ resourceLabel }}&nbsp;<span i18n="@@include">include</span
                                    ><ng-container
                                        *ngIf="
                                            resourceType === ResourceTypes.SURVEY || resourceType === ResourceTypes.TEST
                                        "
                                    >
                                        {{ items.length }}
                                        <span i18n="@@questions">Questions</span>
                                    </ng-container>
                                </span>
                            </div>
                            <ng-container
                                *ngIf="
                                    resourceType === ResourceTypes.COURSE ||
                                    resourceType === ResourceTypes.E_COURSE ||
                                    resourceType === ResourceTypes.SCORM
                                "
                            >
                                <div
                                    (click)="
                                        resource.opportunity_id
                                            ? takeResource(resource, user)
                                            : startCoursePopUp(resource, user, item)
                                    "
                                    class="res-bull mt-1"
                                    *ngFor="let item of items; let index = index"
                                >
                                    <ng-container *ngIf="resourceType !== ResourceTypes.COURSE">
                                        <span class="index" [class.taken-task]="!!item.child_opportunity_done">{{
                                            index + 1
                                        }}</span>
                                        <span
                                            class="res-item-name"
                                            [class.ecourse]="
                                                resourceType === ResourceTypes.E_COURSE ||
                                                resourceType === ResourceTypes.SCORM
                                            "
                                            [class.parent]="!item.parent_id"
                                            >{{ item.name }}</span
                                        >
                                    </ng-container>
                                    <div class="course-items-bull" *ngIf="resourceType === ResourceTypes.COURSE">
                                        <span class="index">{{ index + 1 }}</span>

                                        <app-image-view
                                            [smallSpinner]="true"
                                            [media_id]="item.media$"
                                            [proportional]="true"
                                        ></app-image-view>
                                        <span class="res-item-name">{{ item.name }}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="resourceType === ResourceTypes.EVENT && resource.agenda">
                        <div class="res-items mt-1" fxLayout="column">
                            <div fxLayoutGap="7px" fxLayoutAlign="start center" class="items-label">
                                <mat-icon>ballot</mat-icon>
                                <span i18n>Agenda</span>
                            </div>

                            <div class="res-bull mt-1">
                                <div [innerHtml]="styleInnerHTML(resource.agenda)"></div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="right-info-wrapper">
                    <div class="right-top-wrapper" fxLayoutAlign="space-between start" fxLayout="column">
                        <!-- lang, date, ...... in desktop -->
                        <div *ngIf="!(isMobile | async)" class="play-btn" fxLayoutGap="5px" fxLayout="column">
                            <ng-container
                                [ngTemplateOutlet]="actionBtn"
                                [ngTemplateOutletContext]="{ user: user }"
                            ></ng-container>
                            <div class="small-info flag item-lang-main mt-1">
                                <mat-icon>flag</mat-icon>
                                <div class="dates-wrapper">
                                    <span>
                                        {{ resourceLabel }}&nbsp;
                                        <span i18n="@@Language">Language </span>
                                    </span>
                                    <app-language-selector
                                        [language_id]="resource.language_id"
                                        class="icon-resource-builder"
                                        fxFlex="0 0 auto"
                                    ></app-language-selector>
                                </div>
                            </div>
                            <div *ngIf="resource.public" class="timer-off small-info">
                                <mat-icon>public</mat-icon>
                                <span>
                                    {{ resourceLabel }}&nbsp;
                                    <span i18n="@@isPublic">is public </span>
                                </span>
                            </div>
                            <div class="timer-off small-info">
                                <mat-icon>publish</mat-icon>
                                <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <span i18n>Published by</span>
                                    <ng-container
                                        [ngTemplateOutlet]="publishedBy"
                                        [ngTemplateOutletContext]="{ resource: resource }"
                                    ></ng-container>
                                </span>
                            </div>
                            <div *ngIf="resourceType === ResourceTypes.EVENT" class="timer-off small-info">
                                <mat-icon>diversity_2</mat-icon>
                                <span> {{ ResourceTypes.eventType(resourceType) }} </span>
                            </div>
                            <div
                                *ngIf="resourceType === ResourceTypes.COURSE || resourceType === ResourceTypes.EVENT"
                                class="timer-off small-info"
                            >
                                <ng-container
                                    [ngTemplateOutlet]="resAvailability"
                                    [ngTemplateOutletContext]="{ resource: resource }"
                                ></ng-container>
                            </div>
                        </div>
                        <div class="title-des-wrapper" [ngClass]="{ 'w-70': !resource.description }">
                            <div class="mobile-top-part">
                                <div class="kol-title-wrapper">
                                    <div *ngIf="(isMobile | async) && resource.public" class="kd-lib">
                                        <img src="assets/images/KD_KOL_logo_long.png" alt="KlickData" />
                                    </div>
                                    <h2 data-testid="resource-detail-title">
                                        {{ resource.title }}
                                    </h2>
                                </div>

                                <div class="main-img mobile-main-img" *ngIf="isMobile | async">
                                    <app-image-view
                                        *ngIf="!(trailerMedia$ | async)"
                                        [media_id]="resource.media$"
                                        (srcLoaded)="mediaUrl = $event"
                                    ></app-image-view>
                                    <app-media-view
                                        class="trailer-media"
                                        *ngIf="trailerMedia$ | async"
                                        [media]="trailerMedia$ | async"
                                    >
                                    </app-media-view>
                                </div>
                            </div>
                            <span *ngIf="resource.bullets" class="desc-res">{{ resource.bullets }}</span>
                            <!-- <div *ngIf="resourceType === ResourceTypes.EVENT">Tutor</div> -->
                            <!-- lang, date, ...... in mobile -->
                            <div *ngIf="isMobile | async" class="mobile-tools">
                                <div class="play-btn-wrapper-mob"></div>
                                <div class="down-arrow-wrapper-mob">
                                    <button (click)="togglePanel(); hideImg = !hideImg" class="expand" mat-icon-button>
                                        <span i18n="@@info">Info</span>
                                        <mat-icon [ngClass]="{ 'rotate-expand-icon': hideImg }">expand_more</mat-icon>
                                    </button>
                                    <ng-container
                                        [ngTemplateOutlet]="actionBtn"
                                        [ngTemplateOutletContext]="{ user: user }"
                                    ></ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="right-middle-wrapper mb-2"
                        [fxLayoutGap]="(isMobile | async) ? '1px' : '3em'"
                        [fxLayout]="(isMobile | async) ? 'column' : 'row'"
                    >
                        <div
                            *ngIf="isMobile | async"
                            fxLayout="row"
                            class="mobile-course-extraInfo-wrapper"
                            fxLayoutAlign="space-between center"
                        >
                            <div class="mobile-course-extraInfo">
                                <mat-accordion displayMode="flat">
                                    <mat-expansion-panel #specsExpansionPanel>
                                        <mat-expansion-panel-header>
                                            <mat-icon>announcement</mat-icon>
                                            <ng-container>
                                                {{ resourceLabel }}&nbsp;
                                                <span i18n="@@specifications">specifications</span>
                                            </ng-container>
                                        </mat-expansion-panel-header>
                                        <!-- Cats -->
                                        <div
                                            *ngIf="resourceCategories$ | async as cats"
                                            fxLayoutAlign="start center"
                                            class="res-details desc-elem cats"
                                        >
                                            <div class="pre">
                                                <mat-icon>apps</mat-icon>
                                            </div>
                                            <mat-chip-list class="mt-1">
                                                <mat-chip
                                                    class="cat-chip-item ml-0"
                                                    *ngFor="let cat of cats"
                                                    (click)="showCatgeoryResources(cat)"
                                                    >{{ cat.title }}</mat-chip
                                                >
                                            </mat-chip-list>
                                        </div>

                                        <!-- Tags -->
                                        <div
                                            *ngIf="resource.tags_attached"
                                            fxLayoutAlign="start center"
                                            class="res-details desc-elem tags"
                                        >
                                            <div class="pre">
                                                <mat-icon>label</mat-icon>
                                            </div>
                                            <mat-chip-list class="mt-1">
                                                <mat-chip
                                                    *ngFor="let tag of resourceTags$ | async"
                                                    (click)="showTagResources(tag)"
                                                    class="tag-chip-item"
                                                >
                                                    <span>{{ tag.name }}</span>
                                                    <app-language-selector
                                                        class="flag tag-chip-lang-select"
                                                        fxFlex="0 0 auto"
                                                        [language_id]="tag.language_id"
                                                    >
                                                    </app-language-selector>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                        <!-- Language -->
                                        <div class="res-details desc-elem mob-lang-wrapper">
                                            <div class="pre">
                                                <mat-icon>flag</mat-icon>
                                                <span *ngIf="resourceType === ResourceTypes.COURSE">
                                                    <span i18n="@@courseLanguage">Course Language</span>
                                                </span>
                                                <span *ngIf="resourceType !== ResourceTypes.COURSE">
                                                    {{ resourceLabel }}&nbsp;
                                                    <span i18n="@@Language">Language </span>
                                                </span>
                                            </div>
                                            <span class="normal">
                                                <app-language-selector
                                                    [language_id]="resource.language_id"
                                                    class="icon-resource-builder"
                                                    fxFlex="0 0 auto"
                                                ></app-language-selector>
                                            </span>
                                        </div>

                                        <!-- Duration -->
                                        <div *ngIf="resource.duration" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>timelapse</mat-icon>
                                                <span *ngIf="resourceType === ResourceTypes.COURSE">
                                                    <span i18n="@@courseDuration">Course duration</span>
                                                </span>
                                                <span *ngIf="resourceType !== ResourceTypes.COURSE">
                                                    {{ resourceLabel }}&nbsp;
                                                    <span i18n="@@duration">duration</span>
                                                </span>
                                            </div>
                                            <span class="normal"
                                                >{{
                                                    resource?.duration
                                                        | formatIsoDuration
                                                            : resourceType === ResourceTypes.E_COURSE ||
                                                                  resourceType === ResourceTypes.SCORM
                                                }}
                                            </span>
                                        </div>
                                        <!-- Play time -->
                                        <div *ngIf="resource.time_limit" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>timer</mat-icon>
                                                <span i18n="@@playTime">Play time </span>
                                            </div>
                                            <span class="normal">{{ resource?.time_limit | formatIsoDuration }} </span>
                                        </div>
                                        <!-- Instruuctor refactor needed -->
                                        <!-- Creator -->
                                        <!-- <div *ngIf="resource.instructor?.name" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>engineering</mat-icon>
                                                <span i18n="@@instructor">Instructor </span>
                                            </div>
                                            <span class="normal">
                                                {{ resource.instructor?.name }}
                                            </span>
                                        </div> -->
                                        <!-- Course code -->
                                        <div *ngIf="resource.article_code" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>center_focus_strong</mat-icon>
                                                <span *ngIf="resourceType === ResourceTypes.COURSE">
                                                    <span i18n="@@courseCode">Course code</span>
                                                </span>
                                                <span *ngIf="resourceType === ResourceTypes.TEST">
                                                    <span i18n="@@testCode">Test code</span>
                                                </span>
                                                <span *ngIf="resourceType === ResourceTypes.SURVEY">
                                                    <span i18n="@@surveyCode">Survey code</span>
                                                </span>
                                                <span *ngIf="resourceType === ResourceTypes.E_COURSE">
                                                    <span i18n="@@ecourseCode">E-course code</span>
                                                </span>
                                                <span *ngIf="resourceType === ResourceTypes.SCORM">
                                                    <span i18n="@@scormCode">SCORM code</span>
                                                </span>
                                                <span *ngIf="resourceType === ResourceTypes.MATERIAL">
                                                    <span i18n="@@materialCode">Material code</span>
                                                </span>
                                            </div>
                                            <span class="normal">
                                                {{ resource.article_code }}
                                            </span>
                                        </div>

                                        <!-- Material type -->
                                        <div
                                            *ngIf="resourceType === ResourceTypes.MATERIAL"
                                            class="res-details desc-elem"
                                        >
                                            <div class="pre">
                                                <mat-icon>save</mat-icon>
                                                <span i18n="@@materialType">Material type </span>
                                            </div>

                                            <span class="normal">
                                                {{ resourceType | materialTypeLabel }}
                                            </span>
                                        </div>
                                        <!-- Price -->
                                        <div
                                            *ngIf="resource.price !== 0 && resource.price"
                                            class="res-details desc-elem"
                                        >
                                            <div class="pre">
                                                <mat-icon>local_offer</mat-icon>
                                                <span i18n="@@price">Price </span>
                                            </div>

                                            <span class="normal">
                                                {{ resource.price }}&nbsp;{{ resource.currency }}
                                            </span>
                                        </div>
                                        <!-- Total seats -->
                                        <div *ngIf="resource.total_seats" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>event_seat</mat-icon>
                                                <span>
                                                    {{ resourceLabel }}&nbsp;
                                                    <span i18n="@@seats">seats</span>
                                                </span>
                                            </div>
                                            <span class="normal">
                                                {{ resource.total_seats }}
                                            </span>
                                        </div>
                                        <!-- Extra seats -->
                                        <div *ngIf="resource.extra_seats" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>weekend</mat-icon>
                                                <span>
                                                    {{ resourceLabel }}&nbsp;
                                                    <span i18n="@@extraSeats">extra seats</span>
                                                </span>
                                            </div>
                                            <span class="normal">
                                                {{ resource.extra_seats }}
                                            </span>
                                        </div>

                                        <!-- End reward -->
                                        <div *ngIf="resource.examination?.label" class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>military_tech</mat-icon>
                                                <span i18n="@@endReward">End reward </span>
                                            </div>
                                            <span class="middle-details">
                                                {{ resource.examination?.label }}
                                            </span>
                                        </div>
                                        <!-- Creator -->
                                        <div class="res-details desc-elem">
                                            <div class="pre">
                                                <mat-icon>account_circle</mat-icon>
                                                <span i18n>Created by </span>
                                            </div>
                                            <span class="middle-details">
                                                {{ resource.author_name || $any(resource.author$ | async)?.name }}
                                            </span>
                                        </div>

                                        <!-- Screenshot img -->
                                        <div
                                            class="res-details desc-elem"
                                            *ngIf="
                                                resource.medias?.screenshot?.length > 0 &&
                                                resource.medias?.screenshot[0]
                                            "
                                        >
                                            <div class="pre">
                                                <mat-icon>center_focus_strong</mat-icon>
                                                <span i18n="@@screenshotImage">Screenshot image </span>
                                            </div>
                                            <div class="middle-details-img">
                                                <div class="screenshoot-img-wrapper first-screenshot">
                                                    <app-image-view
                                                        [media_id]="resource.medias.screenshot[0]"
                                                        [paddingBottom]="'200px'"
                                                    >
                                                    </app-image-view>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>
                        <!-- First line after BG on mobie -->
                        <div
                            *ngIf="isMobile | async"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            class="mobile-right-middle m-0"
                        >
                            <!-- Instruuctor refactor needed -->
                            <!-- <div
                                *ngIf="!resource.instructor?.name"
                                fxLayoutGap="4px"
                                fxLayout="column"
                                fxLayoutAlign="start start"
                                class="creator-inst-wrapper-mobile ml-10"
                                [ngClass]="{ authorNameExistLetters: showAuthorName }"
                            >
                                <div fxLayoutAlign="center start" fxLayout="column">
                                    <div
                                        *ngIf="!hideImg"
                                        fxLayoutAlign="center center"
                                        fxLayout="column"
                                        class="user-img-wrapper"
                                    >
                                        <button
                                            class="toggle-author-name"
                                            (click)="showAuthorName = !showAuthorName"
                                            mat-icon-button
                                        >
                                            <mat-icon [ngClass]="{ 'rotate-expand-icon': showAuthorName }"
                                                >expand_more</mat-icon
                                            >
                                        </button>
                                        <div class="user-img">
                                            {{
                                                resource.author_name || $any(resource.author$ | async)?.name | nameSign
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        [ngClass]="{ 'fix-layout': hideImg }"
                                        fxLayoutAlign="center start"
                                        fxLayout="column"
                                        class="inst-name-wrapper"
                                    >
                                        <div
                                            *ngIf="showAuthorName"
                                            class="instructor"
                                            fxLayoutGap="5px"
                                            fxLayoutAlign="center center"
                                        >
                                            <mat-icon>account_circle</mat-icon>
                                            <span i18n="@@author">Author</span>
                                        </div>
                                        <div *ngIf="showAuthorName" class="instructor-name">
                                            {{ resource.author_name || $any(resource.author$ | async)?.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngIf="resource.instructor?.name"
                                fxLayoutGap="4px"
                                fxLayout="column"
                                fxLayoutAlign="start start"
                                class="creator-inst-wrapper-mobile ml-10"
                                [ngClass]="{ authorNameExist: showAuthorName }"
                            >
                                <div fxLayoutAlign="center start" fxLayout="column">
                                    <div *ngIf="!hideImg" fxLayoutAlign="center center" fxLayout="column">
                                        <div fxLayout="row" class="user-img">
                                            <ng-container *ngIf="resource.instructor?.images?.length > 0">
                                                <div
                                                    *ngFor="let imgId of resource.instructor?.images"
                                                    class="img-wrapper instructor-img"
                                                >
                                                    <app-image-view
                                                        [scope]="AppScope.USERS"
                                                        [media_id]="imgId"
                                                        [paddingBottom]="'52px'"
                                                    >
                                                    </app-image-view>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="!resource.instructor?.images?.length">
                                                <div class="user-img mob-img-auth">
                                                    {{ resource.instructor?.name | nameSign }}
                                                </div>
                                            </ng-container>

                                            <button
                                                class="toggle-author-name"
                                                (click)="showAuthorName = !showAuthorName"
                                                mat-icon-button
                                            >
                                                <mat-icon [ngClass]="{ 'rotate-expand-icon': showAuthorName }"
                                                    >expand_more</mat-icon
                                                >
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        [ngClass]="{ 'fix-layout': hideImg }"
                                        fxLayoutAlign="center start"
                                        fxLayout="column"
                                        class="inst-name-wrapper"
                                    >
                                        <div
                                            *ngIf="showAuthorName"
                                            class="instructor"
                                            fxLayoutGap="5px"
                                            fxLayoutAlign="center center"
                                        >
                                            <mat-icon>engineering</mat-icon>
                                            <span i18n="@@instructor">Instructor</span>
                                        </div>
                                        <div *ngIf="showAuthorName" class="instructor-name">
                                            <span *ngIf="resource.instructor?.name">{{
                                                resource.instructor?.name
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div *ngIf="isMobile | async" fxLayoutAlign="center center" class="social-icons m-0">
                                <button
                                    class="grey"
                                    matTooltip="Add to favorite"
                                    i18n-matTooltip="@@addToFavorite"
                                    (click)="favoriteResource(resource)"
                                    mat-icon-button
                                    fxFlex="0 0 auto"
                                >
                                    <mat-icon>{{ resource.favorite ? 'star' : 'star_border' }}</mat-icon>
                                </button>
                                <button
                                    class="grey"
                                    i18n-matTooltip="@@like"
                                    matTooltip="Like"
                                    (click)="likeResource(resource)"
                                    mat-icon-button
                                    fxFlex="0 0 auto"
                                >
                                    <mat-icon>{{ resource.like ? 'favorite' : 'favorite_border' }}</mat-icon>
                                </button>
                                <button
                                    *ngIf="resource.downloads"
                                    class="grey"
                                    matTooltip="Download"
                                    i18n-matTooltip="@@download"
                                    (click)="download(resource)"
                                    mat-icon-button
                                    fxFlex="0 0 auto"
                                >
                                    <mat-icon>save_alt</mat-icon>
                                </button>

                                <!-- Share btns here -->
                                <ng-container
                                    *ngIf="resource.last_publish"
                                    [ngTemplateOutlet]="shareTemp"
                                    [ngTemplateOutletContext]="{ resource: resource }"
                                ></ng-container>
                                <ng-container
                                    *ngIf="resource.published"
                                    [ngTemplateOutletContext]="{ resource: resource }"
                                    [ngTemplateOutlet]="inviteBtn"
                                ></ng-container>
                                <button
                                    *ngIf="
                                        user.role_value !== 'user' &&
                                        user.role_value !== 'guest' &&
                                        user.canAssign(resource)
                                    "
                                    matTooltip="Assign"
                                    i18n-matTooltip="@@assign"
                                    (click)="assign(resource)"
                                    mat-icon-button
                                    fxFlex="0 0 auto"
                                    class="green"
                                >
                                    <mat-icon>assignment_ind</mat-icon>
                                </button>
                                <ng-container
                                    *ngIf="
                                        (resourceType === ResourceTypes.E_COURSE && user.role_value === 'superadmin') ||
                                        resourceType !== ResourceTypes.E_COURSE
                                    "
                                >
                                    <div fxFlex="0 0 auto" *ngIf="user.canEdit(resource)">
                                        <button
                                            i18n-matTooltip="@@edit"
                                            (click)="editResource(resource, user.isAdmin())"
                                            matTooltip="Edit"
                                            class="green"
                                            mat-icon-button
                                        >
                                            <mat-icon>create</mat-icon>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <mat-divider *ngIf="isMobile | async"></mat-divider>
                        <!-- Course items on mobile -->
                        <ng-container *ngIf="resourceType !== ResourceTypes.MATERIAL">
                            <div *ngIf="isMobile | async" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="mobile-course-include" *ngIf="resourceItems$ | async; let items">
                                    <div
                                        class="item-include-mob"
                                        *ngIf="
                                            resourceType === ResourceTypes.SURVEY || resourceType === ResourceTypes.TEST
                                        "
                                    >
                                        <mat-icon>category</mat-icon>
                                        <ng-container>
                                            {{ resourceLabel }}&nbsp;
                                            <span style="margin-left: 3px" i18n="@@include">include</span>
                                        </ng-container>
                                        &nbsp;{{ items.length }}&nbsp;
                                        <span i18n="@@questions">Questions</span>
                                    </div>
                                    <mat-accordion
                                        *ngIf="
                                            resourceType === ResourceTypes.COURSE ||
                                            resourceType === ResourceTypes.E_COURSE ||
                                            resourceType === ResourceTypes.SCORM
                                        "
                                        displayMode="flat"
                                    >
                                        <mat-expansion-panel class="include-expansion-panel" [expanded]="true">
                                            <mat-expansion-panel-header>
                                                <mat-icon>category</mat-icon>
                                                <ng-container>
                                                    {{ resourceLabel }} &nbsp;
                                                    <span style="margin-right: 3px" i18n="@@include">include</span>
                                                </ng-container>
                                                &nbsp;({{ items.length }})
                                            </mat-expansion-panel-header>
                                            <div
                                                (click)="startCoursePopUp(resource, user)"
                                                class="res-bull"
                                                *ngFor="let item of items; let index = index"
                                                data-testid="resource-detail-item"
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        resourceType === ResourceTypes.E_COURSE ||
                                                        resourceType === ResourceTypes.SCORM
                                                    "
                                                >
                                                    <span
                                                        class="index"
                                                        [class.taken-task]="!!item.child_opportunity_done"
                                                        >{{ index + 1 }}</span
                                                    >
                                                    <span
                                                        class="res-item-name ecourse"
                                                        [class.parent]="!item.parent_id"
                                                        >{{ item.name }}</span
                                                    >
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="
                                                        resourceType !== ResourceTypes.E_COURSE &&
                                                        resourceType !== ResourceTypes.SCORM
                                                    "
                                                >
                                                    <span class="index">{{ index + 1 }}</span>
                                                    <mat-icon
                                                        fontSet="klickdata"
                                                        [fontIcon]="displayCorrectIcon(item.item_type_value)"
                                                        class="kd-icon"
                                                    ></mat-icon>
                                                    <span class="res-item-name">{{ item.name }}</span>
                                                </ng-container>
                                            </div>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            </div>
                            <mat-divider *ngIf="isMobile | async"></mat-divider>
                        </ng-container>
                        <!-- Course main info on mobile -->
                        <div *ngIf="isMobile | async" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="mobile-course-mainInfo" *ngIf="resourceItems$ | async; let items">
                                <div class="mobile-course-info-details">
                                    <mat-expansion-panel [expanded]="true" *ngIf="resource.description">
                                        <mat-expansion-panel-header>
                                            <mat-icon>description</mat-icon>
                                            <span i18n="@@description">Description</span>
                                        </mat-expansion-panel-header>
                                        <span
                                            class="middle-details desc ml-0"
                                            [innerHtml]="styleInnerHTML(resource.description)"
                                        >
                                        </span>
                                    </mat-expansion-panel>
                                    <mat-divider *ngIf="resource.description"></mat-divider>
                                    <!-- Goals -->
                                    <mat-expansion-panel *ngIf="resource.goal">
                                        <mat-expansion-panel-header>
                                            <mat-icon>task_alt</mat-icon>
                                            <span i18n="@@goal">Goal</span>
                                        </mat-expansion-panel-header>
                                        <span class="middle-details ml-0">
                                            {{ resource.goal }}
                                        </span>
                                    </mat-expansion-panel>
                                    <mat-divider *ngIf="resource.goal"></mat-divider>
                                    <!-- Other information -->
                                    <mat-expansion-panel *ngIf="resource.other_info">
                                        <mat-expansion-panel-header>
                                            <mat-icon>info</mat-icon>
                                            <span i18n="@@otherInformation">Other information </span>
                                        </mat-expansion-panel-header>
                                        <span class="middle-details ml-0">
                                            {{ resource.other_info }}
                                        </span>
                                    </mat-expansion-panel>
                                    <mat-divider *ngIf="resource.other_info"></mat-divider>
                                    <!-- Instr -->

                                    <mat-expansion-panel
                                        *ngIf="resource.instructions && resourceType !== ResourceTypes.MATERIAL"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-icon>subject</mat-icon>
                                            <span i18n="@@instruction">Instruction</span>
                                        </mat-expansion-panel-header>
                                        <span class="middle-details ml-0">
                                            {{ resource.instructions }}
                                        </span>
                                    </mat-expansion-panel>
                                    <mat-divider
                                        *ngIf="resource.instructions && resourceType !== ResourceTypes.MATERIAL"
                                    ></mat-divider>
                                    <mat-expansion-panel
                                        *ngIf="resource.instructions && resourceType === ResourceTypes.MATERIAL"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-icon>subject</mat-icon>
                                            <span i18n>Content information</span>
                                        </mat-expansion-panel-header>
                                        <span
                                            class="middle-details ml-0"
                                            [innerHtml]="styleInnerHTML(resource.instructions)"
                                        >
                                        </span>
                                    </mat-expansion-panel>
                                    <mat-divider
                                        *ngIf="resource.instructions && resourceType === ResourceTypes.MATERIAL"
                                    ></mat-divider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-footer fxFlex="1 1 auto"></app-footer>
        </div>
        <!-- <app-footer></app-footer> -->
    </div>
</div>

<ng-template #small_loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container mt-2">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>

<ng-template #shareTemp let-resource="resource">
    <button
        *ngIf="!(shareLoading | async); else shareLoadTemp"
        class="grey"
        fxFlex="0 0 auto"
        matTooltip="Share"
        i18n-matTooltip="@@share"
        mat-icon-button
        (click)="shareService.openShareDialog(resource, shareLoading)"
    >
        <mat-icon>share</mat-icon>
    </button>
</ng-template>
<ng-template #inviteBtn let-resource="resource">
    <button
        class="green"
        matTooltip="Invite a friend"
        i18n-matTooltip
        (click)="invite(resource)"
        mat-icon-button
        fxFlex="0 0 auto"
    >
        <mat-icon>outgoing_mail</mat-icon>
    </button>
</ng-template>

<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>

<ng-template #educators let-resource="resource">
    <div class="educators-wrap-small" *ngIf="$any(resource.educators$ | async); let educators">
        <ng-container *ngIf="educators.length === 1">
            <div class="manager-wrapper" fxLayoutAlign="center start" fxLayout="column">
                <app-image-view
                    *ngIf="educators[0].media_id"
                    class="single-img"
                    [scope]="AppScope.USERS"
                    [media_id]="educators[0].media_id"
                    [paddingBottom]="'52px'"
                >
                </app-image-view>
                <div class="default-inst-img-def" *ngIf="!educators[0].media_id">
                    <mat-icon>engineering</mat-icon>
                </div>

                <div class="manager-name">{{ educators[0].name }}</div>
            </div>
        </ng-container>
        <ng-container *ngIf="educators.length === 2">
            <div class="manager-wrapper" fxLayoutAlign="center start" fxLayout="column">
                <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="-50px">
                    <app-image-view
                        *ngIf="educators[0].media_id"
                        class="double-img"
                        [scope]="AppScope.USERS"
                        [media_id]="educators[0].media_id"
                        [paddingBottom]="'52px'"
                    >
                    </app-image-view>
                    <app-image-view
                        *ngIf="educators[1].media_id"
                        class="double-img"
                        [scope]="AppScope.USERS"
                        [media_id]="educators[1].media_id"
                        [paddingBottom]="'60px'"
                    >
                    </app-image-view>
                    <div class="default-inst-img-def" *ngIf="!educators[0].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="default-inst-img-def" *ngIf="!educators[1].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                </div>
                <div class="manager-name">{{ educators[0].name }} & {{ educators[1].name }}</div>
            </div>
        </ng-container>
        <ng-container *ngIf="educators.length > 2">
            <div class="manager-wrapper" fxLayoutAlign="center start" fxLayout="column">
                <div fxLayoutAlign="center center" fxLayout="row">
                    <app-image-view
                        *ngIf="educators[0].media_id"
                        class="multi-img"
                        [scope]="AppScope.USERS"
                        [media_id]="educators[0].media_id"
                        [paddingBottom]="'60px'"
                    >
                    </app-image-view>
                    <app-image-view
                        *ngIf="educators[1].media_id"
                        class="multi-img second"
                        [scope]="AppScope.USERS"
                        [media_id]="educators[1].media_id"
                        [paddingBottom]="'60px'"
                    >
                    </app-image-view>
                    <div class="default-inst-img-def multi" *ngIf="!educators[0].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="default-inst-img-def multi second" *ngIf="!educators[1].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="remain-managers" (click)="showManagers(educators, resource)">
                        +{{ educators.length - 2 }}
                    </div>
                </div>
                <div class="manager-name">{{ educators[0].name }} & {{ educators[1].name }}</div>
                <div class="manager-name" (click)="showManagers(educators, resource)">& Others</div>
            </div>
        </ng-container>
    </div>
</ng-template>
<ng-template #instructor let-resource="resource">
    <div *ngIf="$any(resource.managers$ | async); let managers">
        <ng-container *ngIf="managers.length === 1">
            <div class="manager-wrapper" fxLayoutAlign="center center" fxLayout="column">
                <app-image-view
                    *ngIf="managers[0].media_id"
                    class="single-img"
                    [scope]="AppScope.USERS"
                    [media_id]="managers[0].media_id"
                    [paddingBottom]="'122px'"
                >
                </app-image-view>
                <div class="default-inst-img-def" *ngIf="!managers[0].media_id">
                    <mat-icon>engineering</mat-icon>
                </div>
                <div class="instructor" fxLayoutGap="5px" fxLayoutAlign="center center">
                    <mat-icon>engineering</mat-icon>
                    <div *ngIf="resourceType === ResourceTypes.EVENT" i18n>Tutor</div>
                    <div *ngIf="resourceType !== ResourceTypes.EVENT" i18n>Author</div>
                </div>
                <div class="manager-name">{{ managers[0].name }}</div>
            </div>
        </ng-container>
        <ng-container *ngIf="managers.length === 2">
            <div class="manager-wrapper" fxLayoutAlign="center center" fxLayout="column">
                <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="-50px">
                    <app-image-view
                        *ngIf="managers[0].media_id"
                        class="double-img"
                        [scope]="AppScope.USERS"
                        [media_id]="managers[0].media_id"
                        [paddingBottom]="'122px'"
                    >
                    </app-image-view>
                    <app-image-view
                        *ngIf="managers[1].media_id"
                        class="double-img"
                        [scope]="AppScope.USERS"
                        [media_id]="managers[1].media_id"
                        [paddingBottom]="'122px'"
                    >
                    </app-image-view>
                    <div class="default-inst-img-def" *ngIf="!managers[0].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="default-inst-img-def" *ngIf="!managers[1].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                </div>
                <div class="instructor" fxLayoutGap="5px" fxLayoutAlign="center center">
                    <mat-icon>engineering</mat-icon>
                    <div *ngIf="resourceType === ResourceTypes.EVENT" i18n>Tutors</div>
                    <div *ngIf="resourceType !== ResourceTypes.EVENT" i18n>Authors</div>
                </div>
                <div class="manager-name">{{ managers[0].name }} & {{ managers[1].name }}</div>
            </div>
        </ng-container>
        <ng-container *ngIf="managers.length > 2">
            <div class="manager-wrapper" fxLayoutAlign="center center" fxLayout="column">
                <div fxLayoutAlign="center center" fxLayout="row">
                    <app-image-view
                        *ngIf="managers[0].media_id"
                        class="multi-img"
                        [scope]="AppScope.USERS"
                        [media_id]="managers[0].media_id"
                        [paddingBottom]="'96px'"
                    >
                    </app-image-view>
                    <app-image-view
                        *ngIf="managers[1].media_id"
                        class="multi-img second"
                        [scope]="AppScope.USERS"
                        [media_id]="managers[1].media_id"
                        [paddingBottom]="'96px'"
                    >
                    </app-image-view>
                    <div class="default-inst-img-def multi" *ngIf="!managers[0].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="default-inst-img-def multi second" *ngIf="!managers[1].media_id">
                        <mat-icon>engineering</mat-icon>
                    </div>
                    <div class="remain-managers" (click)="showManagers(managers, resource)">
                        +{{ managers.length - 2 }}
                    </div>
                </div>
                <div class="instructor" fxLayoutGap="5px" fxLayoutAlign="center center">
                    <mat-icon>engineering</mat-icon>
                    <div *ngIf="resourceType === ResourceTypes.EVENT" i18n>Tutors</div>
                    <div *ngIf="resourceType !== ResourceTypes.EVENT" i18n>Authors</div>
                </div>
                <div class="manager-name">{{ managers[0].name }} & {{ managers[1].name }}</div>
                <div class="manager-name" (click)="showManagers(managers, resource)">& Others</div>
            </div>
        </ng-container>
    </div>

    <ng-template #author_img>
        <div class="author-wrapper" fxLayoutAlign="center center" fxLayout="column">
            <div class="user-img">
                {{ resource.author_name || $any(resource.author$ | async)?.name | nameSign }}
            </div>
            <div class="instructor" fxLayoutGap="5px" fxLayoutAlign="center center">
                <mat-icon>account_circle</mat-icon>
                <span i18n>Created by </span>
            </div>
            <div>
                {{ resource.author_name || $any(resource.author$ | async)?.name }}
            </div>
        </div>
    </ng-template>
</ng-template>
<ng-template #resAvailability let-resource="resource">
    <div *ngIf="resource.always_available" class="timer-off small-info times-parent">
        <mat-icon>timer_off</mat-icon>
        <span i18n="@@alwaysAvailable">Always available</span>
    </div>
    <!-- <div *ngIf="resource.not_set_yet" class="timer-off small-info times-parent">
        <mat-icon>timer_off</mat-icon>
        <span i18n>Date not set yet</span>
    </div> -->
    <div
        *ngIf="resource.start_date?.isAfter(moment) && resource.end_date?.isAfter(moment) && !resource.always_available"
        class="small-info timer-off times-parent"
    >
        <mat-icon>timer</mat-icon>
        <div class="dates-wrapper times">
            <!-- <span i18n="@@availableBetween">Available between</span> -->
            <div>
                <span>{{ resource.start_date | dateFormatLocalized : 'MMM d, y' }}</span> /
                <span>{{ resource.end_date | dateFormatLocalized : 'MMM d, y' }}</span>
            </div>
        </div>
    </div>
    <div
        *ngIf="
            resource.start_date?.isBefore(moment) && resource.end_date?.isAfter(moment) && !resource.always_available
        "
        class="small-info timer-off times-parent"
    >
        <mat-icon>timelapse</mat-icon>
        <div class="dates-wrapper times">
            <!-- <span i18n="@@availableBetween">Available between</span> -->
            <div>
                <span>{{ resource.start_date | dateFormatLocalized : 'MMM d, y' }}</span> /
                <span>{{ resource.end_date | dateFormatLocalized : 'MMM d, y' }}</span>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #publishedBy let-resource="resource">
    <ng-container *ngIf="resource.staff?.publisher && resource.staff?.publisher[0]">
        <ng-container *ngIf="$any(resource.publishers$ | async); let publishers; else: smallLoading">
            <span>{{ publishers[0].name }}</span>
        </ng-container>
    </ng-container>
</ng-template>
<ng-template #academyLogo let-resource="resource">
    <ng-container *ngIf="resource.public">
        <img src="assets/images/KD_KOL_logo_long_white.png" alt="KlickData" />
    </ng-container>
    <ng-container *ngIf="!resource.public">
        <ng-container *ngIf="$any(resource.publishers$ | async); let publishers; else: smallLoading">
            <app-logotype [image]="publishers[0].media_url" [alt]="publishers[0].name"></app-logotype>
        </ng-container>
    </ng-container>
</ng-template>
<!-- Same button as the desktop details: Signoff for a joined event, otherwise ResourcePlayabilityService -->
<ng-template #actionBtn let-user="user">
    <button
        *ngIf="resourceType === ResourceTypes.EVENT && resource.opportunity_id; else playableBtn"
        (click)="signoffEvent(resource, user)"
        class="take"
        mat-raised-button
        data-testid="resource-detail-action"
        [ngStyle]="{ 'background-color': '#3e5365', color: '#fff' }"
    >
        <mat-icon>event_available</mat-icon>
        <span i18n>Signoff</span>
    </button>
    <ng-template #playableBtn>
        <button
            *ngIf="resource.playableResource$ | async; let spec"
            (click)="takeResource(resource, user)"
            class="take"
            mat-raised-button
            data-testid="resource-detail-action"
            [ngStyle]="{ 'background-color': spec.bg, color: spec.fg }"
        >
            <mat-icon>{{ spec.icon }}</mat-icon>
            <span>{{ spec.label }}</span>
        </button>
    </ng-template>
</ng-template>
<ng-template #smallLoading>
    <app-kd-logo-loading class="small-load-header" size="small"></app-kd-logo-loading>
</ng-template>
